module.exports = __webpack_public_path__ + "static/media/bg-3.bd4438a0.png";